import React from 'react';
import Header from '../Header';
import Footer from '../Footer';

const Layout = ({ children, stickyHeader = false, noFooter }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header sticky={stickyHeader} />
      <main className="flex-1">{children}</main>
      {!noFooter && <Footer />}
    </div>
  );
};

export default Layout;
